<div class="dropdown" style="padding-left: 10px">
	<button class="dropdown-toggle download-button" type="button" data-bs-toggle="dropdown" aria-expanded="false">
		<span class="download-badge tw-bg-gray-500 tw-text-white tw-rounded-full tw-px-2 tw-py-1 tw-text-xs tw-font-semibold tw-mr-2">{{ count || 0 }}</span>
		<i class="fa fa-download tw-mr-2"></i>
		<span class="tw-text-black">Download</span>
		<i class="fa fa-chevron-down download-chevron tw-ml-2"></i>
	</button>
	<div class="dropdown-menu">
		<button *ngIf="csvFormat" class="dropdown-item" type="button" (click)="downloadCsv()">
			<i class="fa fa-file-excel-o tw-text-green-600" aria-hidden="true"></i> Download as CSV
		</button>
		<button *ngIf="xlsxFormat" class="dropdown-item" type="button" (click)="downloadXlsx()">
			<i class="fa fa-file-excel-o tw-text-blue-600" aria-hidden="true"></i> Download as XLSX
		</button>
	</div>
</div>

